import moment from 'moment';
import React, { CSSProperties, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import DotLoader from 'react-spinners/DotLoader';
//import GreenAttributeTransactions from '../../data/prosumer/GreenAttributeTransactions.json';
import { getGreenEnergyTransactionsData } from '../../services/admin.service';
//import { START_DATE } from './common/const'
import { CSVLink } from "react-csv";

const override: CSSProperties = {
    display: "block",
    margin: "auto",
    marginTop: "120px",
    marginBottom: "150px",
    borderColor: "red",
};

interface GreenEnergyTransactionObject {
    meterType: string;
    net_earnings: number;
    traded: {
        name: string,
        cost: string,
        rec: number,
        allocation: string
    },
    open_market: {
        name: string,
        cost: string,
        rec: number,
        allocation: string
    },
    unsold: {
        name: string,
        cost: string,
        rec: number,
        allocation: string
    }
}

function AdminGreenAtributeTransaction() {
    const [data, setData] = useState<GreenEnergyTransactionObject>()
    let [loading, setLoading] = useState(false);
    const color = "#006837";
    //const auth = JSON.parse(localStorage.getItem('auth')!)
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1);

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        setLoading(true);
        const data = await getGreenEnergyTransactionsData(1);
        setData(data.data);
        setLoading(false);
    }

    const netEarnings = data?.net_earnings
    const CFE = data?.traded?.cost
    const CFE_energy = data?.traded?.allocation
    const Unsold = data?.unsold?.cost
    const Unsold_energy = data?.unsold?.allocation
    const csvData = [
        ["NET EARNINGS IN AUGUST", "24/7 CFE", "Unsold"],
        [netEarnings, CFE, Unsold],
        [netEarnings, CFE_energy, Unsold_energy]
    ];

    return (
        <div className='dashboardWidget'>
            <div className='widgetTitle'>
                <h3>Green Attribute Transactions</h3>
            </div>
            {loading ? <DotLoader
                color={color}
                loading={loading}
                cssOverride={override}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
            /> :
                <div className='widgetBody py-4'>
                    <div className='widgetChart'>
                        <Row className='mb-5'>
                            <Col>
                                <p className='text-uppercase h5 mb-0 w300'>NET EARNINGS IN {moment(new Date(startDate)).format('MMMM').toUpperCase()}</p>
                                <p className='h1 fs3x mt-0 w700 text-secondary'>{data?.net_earnings} ฿</p>
                            </Col>
                        </Row>
                        <hr />
                        <Row className='mt-3'>
                            <Col>
                                <div className='totalConsumption'>
                                    <p className='h5 w700 text-secondary'>24/7 CFE</p>
                                    <p className='h5 mb-1 text-primary '>{data?.traded.cost} ฿</p>
                                    <p className='mb-1'>{data?.traded.allocation} kWh</p>
                                </div>
                            </Col>
                            <Col>
                                <div className='totalConsumption'>
                                    <p className='h5 w700 text-secondary'>Open Market</p>
                                    <p className='h5 mb-1 text-primary '>{data?.open_market.cost} ฿</p>
                                    <p className='mb-1'>{data?.open_market.allocation} kWh</p>
                                </div>
                            </Col>
                            <Col>
                                <div className='totalConsumption'>
                                    <p className='h5 w700 text-secondary'>Unsold</p>
                                    <p className='h5 mb-1 text-primary '>{data?.unsold.cost} ฿</p>
                                    <p className='mb-1'>{data?.unsold.allocation} kWh</p>
                                </div>
                            </Col>

                        </Row>

                    </div>
                    <div className='text-center mt-5'>
                        <CSVLink filename={`Green Attribute Transactions - ${moment(new Date(startDate)).format('MMMM').toUpperCase()}`} data={csvData} className='w700'><i className="fa-solid fa-download"></i> Download as CSV</CSVLink>
                    </div>
                </div>
            }
        </div>
    )
}
export default AdminGreenAtributeTransaction;